export default __webpack_public_path__ + "static/media/placeholder_portfolio03-en-web.df74fced.png";